import { primaryTypography } from 'styles/global/typography/typography';
import { ActiveFiltersText } from 'components/base/ActiveFilters/ActiveFilters';
import { KPIList } from './../shared/index';
import {
  Title,
  StyledToolbarOptions,
  Header,
} from './../KPIWrapper/KPIWrapper';
import styled, { css } from 'styled-components/macro';
import { definitionLabel, definitionValue } from 'styles/base-classes';
import Box from 'components/elements/Box';
import { Header as BaseHeader } from '../shared';

export const Label = styled('dt')`
  ${definitionLabel};
  letter-spacing: 0.05em;
  margin-bottom: ${({ theme }): string => theme.spacing.xxsmall};
  font-size: 13px;
  margin-right: 12px !important;
  letter-spacing: normal;
`;

export const Container = styled('section')<any>`
  padding: ${({ theme }): string =>
    `${theme.spacing.large} ${theme.spacing.large}`};
  background: white;
  ${({ isMobileView, compareMode }): any =>
    isMobileView &&
    css`
      padding: ${({ theme }): string =>
        `${theme.spacing.small} ${theme.spacing.medium}`};
      ${compareMode && 'padding-bottom: 30px;'}
      @media screen and (max-width: 50em) {
        margin: 0 0.5rem;
    `}

  @media screen and (min-width: 50em) {
    width: ${({ theme }): number => theme.layout.smallScreen * 100}%;
    padding: ${({ theme }): string =>
      `${theme.spacing.large} ${theme.spacing.xlarge}`};
    margin: 0 auto;
  }

  @media screen and (min-width: 80em) {
    width: ${({ theme }): number => theme.layout.largeScreen * 100}%;
  }

  ${Header} {
    @media screen and (max-width: 50em) {
      padding-left: 0;
    }
  }

  ${Title} {
    display: flex;
    align-items: center;
    svg {
      margin-right: ${({ theme }): string => theme.spacing.xxsmall};
      display: inline-flex;
      position: relative;
      top: auto;
      left: auto;
      transform: none;
    }

    @media screen and (min-width: 50em) {
      margin-top: 0;
    }
  }

  ${StyledToolbarOptions} {
    @media screen and (min-width: 50em) {
      margin-right: 0;
    }
  }

  ${({ compareMode }): string =>
    compareMode &&
    `
    ${KPIList} {
      padding: 0 2.5em;
      @media screen and (max-width: 50em) {
        padding-left: 0;
      }
    }
    ${ActiveFiltersText} {
      padding-left: 3em;
    }
  `}
`;

export const Value = styled('dd')`
  ${definitionValue};
  ${primaryTypography};
  height: 30px;
  display: inline-flex;
  align-items: center;
  font-size: 1em;
  color: ${({ theme }): string => theme.DeepBlue};
`;

export const StyledChangeArrow = styled('span')<any>`
  color: ${({ isPositive, theme }): string =>
    isPositive ? theme.PositiveChange : theme.NegativeChange};
  display: inline-block;
  font-weight: 600;
  ${({ isMobileView }): any =>
    isMobileView &&
    css`
      position: absolute;
      left: -1em;
    `}
`;

export const KPIContent = styled('div')<any>`
  margin-top: -${({ theme }): string => theme.spacing.small};

  ${({ isMobileView }): any =>
    isMobileView &&
    css`
      margin: ${({ theme }): string =>
        `-${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`};

      ${KPIList} {
        display: flex;
        flex-direction: column;
        padding-left: ${({ theme }): string => `${theme.spacing.large}`};

        li {
          display: flex;
          flex-direction: row;
          font-size: 1em;

          :first-of-type {
            ${Value} {
              font-size: 1em !important;
            }
          }
        }

        ${Label} {
          font-size: 1em;
          margin-bottom: 0;
          height: auto;
          position: relative;
        }

        ${Value} {
          font-size: 1em;
          margin-bottom: 0;
          height: auto;
          margin-left: ${({ theme }): string => `${theme.spacing.small}`};
        }
      }
    `}

  ${KPIList} {
    grid-template-columns: repeat(5, 1fr);

    @media screen and (min-width: 57em) {
      grid-template-columns: repeat(6, 1fr);
    }

    li {
      margin-top: 0px;

      :first-of-type {
        ${Value} {
          font-size: 1.5em;
        }
      }
    }
  }
`;

export const ItemWrapper = styled('li')<any>`
  display: flex;
  align-items: center;
  ${({ isMobileView }) => !isMobileView && `margin-bottom: 7px;`}
  dt {
    margin: 0 7px 0 0;
  }
`;

export const MetricsWrapper = styled(Box)`
  li:first-of-type {
    span {
      font-size: 24px;
    }
  }
`;

export const H3 = styled(BaseHeader)`
  ${({ isMobileView }): string => isMobileView && `margin-bottom: 0;`}
`;
